import React from 'react';
import Footer from '../components/Footer';

export default function PrivacyPage({ navigate }) {
  return (
    <div>
      <div className="page-hero" style={{paddingBottom:40}}>
        <div className="section-label">Legal</div>
        <h1>Privacy Policy</h1>
        <p>Last updated: July 2025</p>
      </div>

      <section style={{maxWidth:780,margin:'0 auto',padding:'56px 5%',lineHeight:1.8}}>
        {[
          {
            title: '1. Introduction',
            body: 'Ark Expert Researchers ("we", "our", or "us") is committed to protecting the privacy and confidentiality of our clients. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use our academic assistance services at arkexpertresearch.com.',
          },
          {
            title: '2. Information We Collect',
            body: 'We collect information you provide directly, including your name, email address, phone number, country, and assignment details when you submit a quote request or contact us. We do not collect sensitive personal data such as government identification numbers or financial account details beyond payment processing.',
          },
          {
            title: '3. How We Use Your Information',
            body: 'Your information is used solely to: (a) process and fulfil your academic assistance request, (b) communicate with you regarding your order status and delivery, (c) send you a unique tracking ID to monitor your assignment progress, and (d) improve our service quality. We do not use your data for unsolicited marketing without your consent.',
          },
          {
            title: '4. Confidentiality & Non-Disclosure',
            body: 'We operate under strict confidentiality. Your personal details, order contents, and any documents you share are never disclosed to your academic institution, employer, or any third party. Our writers and team members are bound by non-disclosure agreements. Your identity remains anonymous throughout the entire process.',
          },
          {
            title: '5. Data Storage & Security',
            body: 'Your data is stored securely using industry-standard encryption (Supabase/PostgreSQL with row-level security). Access to your personal information is restricted to authorised team members only. We do not sell, rent, or trade your personal information to any third parties.',
          },
          {
            title: '6. Cookies',
            body: 'Our website uses minimal cookies necessary for authentication and session management. We do not use tracking cookies for advertising purposes. You may disable cookies in your browser settings, though this may affect certain site functionality such as the client dashboard.',
          },
          {
            title: '7. File Attachments',
            body: 'Any files you upload as part of your quote request (rubrics, instructions, previous work) are stored securely in private storage accessible only to authorised team members. These files are used exclusively to fulfil your order and are deleted upon request.',
          },
          {
            title: '8. Payments',
            body: 'Payment processing is handled by trusted third-party providers (PayPal, card processors). We do not store your full card details on our servers. Payment providers are bound by their own privacy policies and PCI-DSS compliance standards.',
          },
          {
            title: '9. Your Rights',
            body: 'You have the right to request access to the personal data we hold about you, request correction of inaccurate data, request deletion of your data, and withdraw consent for data processing at any time. To exercise these rights, contact us at info@arkexpertresearch.com.',
          },
          {
            title: '10. Changes to This Policy',
            body: 'We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated date. Continued use of our services after changes constitutes acceptance of the updated policy.',
          },
          {
            title: '11. Contact Us',
            body: 'For privacy-related questions or data requests, contact us at: info@arkexpertresearch.com | hello@arkexpertresearch.com | WhatsApp: +1 (618) 815-6526',
          },
        ].map(({ title, body }) => (
          <div key={title} style={{marginBottom:32}}>
            <h2 style={{fontFamily:'Sora,sans-serif',fontSize:'1.1rem',fontWeight:700,color:'#0A1931',marginBottom:10}}>{title}</h2>
            <p style={{fontSize:15,color:'#4b5563',lineHeight:1.8,margin:0}}>{body}</p>
          </div>
        ))}

        <div style={{marginTop:48,background:'#f0f6ff',borderRadius:14,padding:24,border:'1px solid #dbeafe',textAlign:'center'}}>
          <p style={{fontSize:15,color:'#0A1931',marginBottom:16,fontWeight:600}}>Have privacy questions or want to request data deletion?</p>
          <button className="btn-primary" onClick={() => navigate('contact')}>Contact Us</button>
        </div>
      </section>

      <Footer navigate={navigate}/>
    </div>
  );
}
